exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".orderTable{margin-top:20px}.rateTable{margin:30px 0 70px}.centerDiv{text-align:center;margin:50px 0 30px;cursor:pointer}.centerDiv p{font-size:16px;color:#2993ff;margin-bottom:15px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.centerDiv img{width:27px;height:11px}\n", ""]);

// exports
